import { ArenaGuidePage } from '@/components/arena-guide-page'

export function RoleIndexPage() {
  return <ArenaGuidePage kind="roles" />
}
